import ReactDOM from "react-dom/client";
import {
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  Navigate,
} from "react-router-dom";

// css
import "./index.css";
// components
import App from "./App";
import Login from "./pages/login/Login";
import SignUp from "./pages/signup/SignUp";
import NotFound from "./pages/errors/NotFound";
import Dashboard from "./pages/dashboard/Dashboard";
import AccountSettings from "./pages/account-settings/AccountSettings";
import Companies from "./pages/companies/Companies";
import RateSheets from "./pages/rate-sheets/RateSheets";
import Users from "./pages/users/Users";
import AddCompany from "./pages/companies/AddCompany";
import FuelSurcharge from "./pages/fuel-surcharge/FuelSurcharge";
import Project from "./pages/project/Project";
import CustInvoices from "./pages/customer-invoices/CustInvoices";
import VendorInvoices from "./pages/vendor-invoices/VendorInvoices";
import InvoiceDetails from "./pages/vendor-invoices/InvoiceDetails";
import AssetRateSheets from "./pages/asset-rate-sheets/AssetRateSheets";
import CustomerInvoiceDetails from "./pages/customer-invoices/CustomerInvoiceDetails";
import Accruals from "./pages/accruals/Accruals";
import UpdatePassword from "./pages/login/UpdatePassword";
import AdminProtect from "./routes/AdminProtected";
import AdminCompanies from "./pages/admin/AdminCompanies";
import AdminLanding from "./pages/admin/AdminLanding";
import AdminUsers from "./pages/admin/AdminUsers";
import AccountInvoices from "./pages/account-invoices/AccountInvoices";
import CustomerAccountInvoices from "./pages/account-invoices/customer/CustomerAccountInvoices";
import VendorAccountInvoices from "./pages/account-invoices/vendor/VendorAccountInvoices";
import AccountCustomerInvoiceDetails from "./pages/account-invoices/customer/AccountCustomerInvoiceDetails";
import CompanyCarriers from "./pages/company-carrier-drivers/CompanyCarriers";
import CarrierDrivers from "./pages/company-carrier-drivers/CarrierDrivers";
import AccountVendorInvoiceDetails from "./pages/account-invoices/vendor/AccountVendorInvoiceDetails";
import FullAccess from "./routes/FullAccess";
import AccountReceivedInvoices from "./pages/account-invoices/received/AccountReceivedInvoices";
import AccountReceivedInvoiceDetails from "./pages/account-invoices/received/AccountReceivedInvoiceDetails";
import CompanySettingsLanding from "./pages/company-settings/CompanySettingsLanding";
import CompanyDrivers from "./pages/company-drivers/CompanyDrivers";
import ProjectInvoices from "./pages/project/ProjectInvoices";

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route>
      <Route element={<AdminProtect />}>
        <Route path="/admin" element={<AdminLanding />}>
          <Route index element={<Navigate to="companies" replace />} />
          <Route path="companies" element={<AdminCompanies />} />
          <Route path="admin-users" element={<AdminUsers />} />
        </Route>
      </Route>

      <Route path="password-reset/:token" element={<UpdatePassword />} />

      <Route path="/" element={<App />}>
        <Route index element={<Navigate to="dashboard" replace />} />

        <Route element={<FullAccess />}>
          <Route
            path="dashboard"
            element={<Dashboard />}
            errorElement={<Login />}
          />

          <Route path="account-invoices" element={<AccountInvoices />}>
            <Route index element={<Navigate to="customer" replace />} />

            <Route path="customer" element={<CustomerAccountInvoices />}>
              <Route
                path=":invId"
                element={<AccountCustomerInvoiceDetails />}
              />
            </Route>

            <Route path="vendor" element={<VendorAccountInvoices />}>
              <Route path=":invId" element={<AccountVendorInvoiceDetails />} />
            </Route>
          </Route>

          <Route path="company-carriers" element={<CompanyCarriers />}>
            <Route path=":id" element={<CarrierDrivers />} />
          </Route>

          <Route path="company-drivers" element={<CompanyDrivers />} />

          <Route path="project/:id" element={<Project />} />
          <Route path="project/:id/invoices" element={<ProjectInvoices />}>
            <Route
              index
              element={<Navigate to="customer-invoices" replace />}
            />
            <Route path="customer-invoices" element={<CustInvoices />}>
              <Route
                path=":invId/:isAsset"
                element={<CustomerInvoiceDetails />}
              />
            </Route>
            <Route path="vendor-invoices" element={<VendorInvoices />}>
              <Route path=":type/:invId" element={<InvoiceDetails />} />
            </Route>
          </Route>

          <Route path="project/:id/accruals" element={<Accruals />} />

          <Route path="settings">
            <Route
              path="company-settings"
              element={<CompanySettingsLanding />}
            />
            <Route path="companies" element={<Companies />}>
              <Route path="0" element={<AddCompany />} />
            </Route>
            <Route path="rate-sheets" element={<RateSheets />} />
            <Route path="fuel-surcharge" element={<FuelSurcharge />} />
            <Route path="asset-rate-sheets" element={<AssetRateSheets />} />
          </Route>
        </Route>
        <Route path="account-invoices" element={<AccountInvoices />}>
          <Route path="received" element={<AccountReceivedInvoices />}>
            <Route
              path=":invId/:projectId"
              element={<AccountReceivedInvoiceDetails />}
            />
          </Route>
        </Route>
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<SignUp />} />
        <Route path="account-settings" element={<AccountSettings />} />
        <Route path="settings/users" element={<Users />} />

        <Route path="*" element={<NotFound />} />
      </Route>
    </Route>,
  ),
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <RouterProvider router={router} />,
  // </React.StrictMode>
);
